angular.module('jv.Admin.Users')
    .factory('modalObjectTemplateFAC', [function () {
        return {
            get: function(typeObject) {
                return {
                    type: typeObject.name.toUpperCase(),
                    show: true,
                    headText: typeObject.title,
                    showCC: false,
                    showBCC: false,
                    showLinks: false,
                    templates: [],
                    templatePlaceHolder: typeObject.placeholder,
                    subjectPlaceHolder: typeObject.subjectPlaceholder
                };
            },
            setDefault: function(templates) {
                var selectedTemplate = {};
                angular.forEach(templates, function(templt){
                    if(templt['default']){
                        selectedTemplate.template = templt;
                        selectedTemplate.subject = templt.subject;
                        selectedTemplate.body = templt.body;
                    }
                });
                return selectedTemplate;
            }
        };
    }])
    .controller('jvAdminUsersDeleteThresholdSettingsController',
        ['$scope', 'adminUserSVC','$rootScope', '$location', '$route', 'breadcrumbsResolve', 'enumToValueMap', 'commonListActionsFAC', '$timeout', 'modalObjectTemplateFAC','Reqs',
            function($scope, adminUserSVC, $rootScope, $location, $route, breadcrumbsResolve, enumToValueMap, commonListActionsFAC, $timeout, modalObjectTemplateFAC, Reqs) {
        	$scope.flags.loading = true;
    		$scope.showEdit = false;
    		$scope.breadcrumbsConfig = breadcrumbsResolve;
    		$scope.settings = {};
    		$scope.thresholdPercentage=null;
           	$scope.settings.thresholds=[
           		     {id:"0", text: "0%"},
           	    	 {id:"1", text: "10%"},
                     {id:"2", text: "20%"},
                     {id:"3", text: "30%"},
                     {id:"4", text: "40%"},
                     {id:"5", text: "50%"},
                     {id:"6", text: "60%"},
                     {id:"7", text: "70%"},
                     {id:"8", text: "80%"},
                     {id:"9", text: "90%"},
                     {id:"10", text: "100%"}
           	     ];
               $scope.getDeleteThreshold=function(){
            	   $scope.flags.loading = true;
            	   var args = {};
            	   adminUserSVC.getDeleteThresholdPercentage(args,function(response){
            		   for(var i=0;i<$scope.settings.thresholds.length;i++){
            			   if($scope.settings.thresholds[i].text.replace('%','')===response.thresholdValue){
            				   $scope.settings.thresholdSelected=$scope.settings.thresholds[i];
            				   break;
            			   }
            		   }
            		   $scope.thresholdPercentage=response.thresholdValue;
            	   });
            	   $scope.showEdit=false;
            	   $scope.flags.loading = false;
               }
               $scope.getDeleteThreshold();
               $scope.editDeleteThresholdSettings=function(){
            	   $scope.showEdit=true;
               }
               
               $scope.cancelDeleteThresholdSettings=function(){
            	   $scope.resetToDefault();
               }
               $scope.saveDeleteThresholdSettings=function(){
            	   var args = {};
            	   args.thresholdPercentage=$scope.settings.thresholdSelected.text.replace('%','');
            	   adminUserSVC.saveDeleteThreshold(args,function(response){
            		   $scope.flags.loading = true;
            		   $scope.getDeleteThreshold();
            	   });
               }
               $scope.resetToDefault=function(){
            	   $scope.showEdit=false; 
               }
        	}
    ]);
